import moment from 'moment';
import XLSX from 'sheetjs-style';
import { DetenteurEntity } from '../../../../entities/detenteur.entity';
import { SECONDARY } from '../../../../shared/colors';

export const generateDetenteurDataToExport = (detenteurs: any[]) => {
  let toExport: any[] = [];
  let index = 1;
  for (let det of detenteurs) {
    toExport.push({
      Index: index,
      'Code client': det.code_referent,
      Nom: det.nom,
      Prénom: det.prenom,
      Email: det.email,
      Adresse: det.adresse,
      Nationalité: det.nationalite,
      Téléphone: det.mobile,
      Gestionnaire: `${det.createur.nom} ${det.createur.prenom}`,
      'Code agence': det.agence.code,
      Agence: det.agence.nom,
      'Code partenaire': det.partenaire.code_referent,
      Partenaire: det.partenaire.nom,
      'Date création': `${moment(det.created_at).format(
        'DD/MM/YYYY HH:mm:ss',
      )}`,
      'Date modification': `${moment(det.updated_at).format(
        'DD/MM/YYYY HH:mm:ss',
      )}`,
    });
    index += 1;
  }

  return toExport;
};

const countColumns = (data: any[]) => {
  let firstLine = data[0];
  return Object.keys(firstLine).length;
};

export const exportDetenteurData = (detenteurs: DetenteurEntity[]) => {
  let wb = XLSX.utils.book_new();
  const detenteursData = generateDetenteurDataToExport(detenteurs);
  let ws1 = XLSX.utils.json_to_sheet(detenteursData);

  // style cells
  let numberCols = countColumns(detenteursData);
  for (let i = 0; i < numberCols; i++) {
    // style table header
    ws1[`${String.fromCharCode(65 + i)}1`].s = {
      font: {
        name: 'Poppins-B',
        sz: 10,
        color: { rgb: 'FFFFFF' },
      },
      fill: {
        bgColor: SECONDARY,
      },
      border: {
        top: { style: 'thin', color: { rgb: 'FFFFFF' } },
        bottom: { style: 'thin', color: { rgb: 'FFFFFF' } },
        left: { style: 'thin', color: { rgb: 'FFFFFF' } },
        right: { style: 'thin', color: { rgb: 'FFFFFF' } },
      },
    };
    // style content of table
    for (let j = 2; j <= detenteursData.length + 1; j++) {
      ws1[`${String.fromCharCode(65 + i)}${j}`].s = {
        font: {
          name: 'Poppins-L',
          sz: 10,
        },
        border: {
          top: { style: 'thin' },
          bottom: { style: 'thin' },
          left: { style: 'thin' },
          right: { style: 'thin' },
        },
      };
    }
  }

  XLSX.utils.book_append_sheet(wb, ws1, 'Clients');
  XLSX.writeFile(
    wb,
    `Etat des clients - ${moment(new Date()).format('DD/MM/YYYY')}.xlsx`,
  );
};
